<ng-container *transloco="let t">
  <authority-labs-base-dialog [dialogRef]="dialogRef" [title]="title">
    <div content>
      <button nz-button class="add-btn" (click)="add()" [disabled]="isEditing">
        הוסף הערה
      </button>

      <nz-table
        nzSize="small"
        [nzData]="notes"
        [nzShowPagination]="false"
        [nzLoading]="isLoading"
      >
        <thead>
          <tr>
            <th class="drag-column"></th>
            <th class="selection" *ngIf="multi"></th>
            <th class="choose-btn"></th>
            <th class="iterator">מס'</th>
            <th class="note-column">הערה</th>
            <th class="default" *ngIf="supportDefault">ברירת מחדל</th>
            <th></th>
          </tr>
        </thead>
        <tbody
          cdkDropList
          [cdkDropListData]="notes"
          (cdkDropListDropped)="drop($event)"
        >
          <tr *ngIf="addNew">
            <td class="drag-column"></td>
            <td class="selection" *ngIf="multi"></td>
            <td class="choose-btn"></td>
            <td class="iterator"></td>
            <td class="note-column">
              <input
                nz-input
                authorityLabsAutofocus
                placeholder="הערה"
                [(ngModel)]="newNote.content"
              />
            </td>
            <td class="default" *ngIf="supportDefault">
              <label nz-checkbox [(ngModel)]="newNote.isDefault"></label>
            </td>
            <td>
              <button
                nz-button
                nzType="link"
                (click)="save(newNote)"
                [disabled]="!newNote.content"
              >
                שמור
              </button>
              <button nz-button nzType="link" (click)="cancel()">בטל</button>
            </td>
          </tr>
          <tr
            *ngFor="let note of notes; index as i"
            cdkDrag
            [cdkDragData]="note"
            [cdkDragDisabled]="isEditing || addNew"
          >
            <ng-container *ngIf="editRowIndex !== i; else editTemplate">
              <td class="drag-column">
                <div cdkDragHandle class="drag-handle">
                  <authority-labs-drag-icon></authority-labs-drag-icon>
                </div>
              </td>
              <td
                class="selection"
                *ngIf="multi"
                [nzChecked]="setOfCheckedId.has(note.id)"
                (nzCheckedChange)="onItemChecked(note.id, $event)"
              ></td>
              <td class="choose-btn">
                <button actions nz-button (click)="chooseOneAndClose(note)">
                  בחר
                </button>
              </td>
              <td class="iterator">{{ i + 1 }}</td>
              <td class="note-column">{{ note.content }}</td>
              <td class="default" *ngIf="supportDefault">
                <span
                  nz-icon
                  nzType="check-square"
                  nzTheme="twotone"
                  *ngIf="note.isDefault"
                ></span>
              </td>
              <td>
                <button
                  nz-button
                  nzType="link"
                  (click)="edit(i)"
                  [disabled]="!canEdit(i)"
                >
                  ערוך
                </button>
                <a
                  nz-button
                  nzType="link"
                  nz-popconfirm
                  nzPopconfirmTitle="בטוח/ה שברצונך למחוק?"
                  (nzOnConfirm)="delete(note)"
                  [disabled]="!canEdit(i)"
                  >מחק</a
                >
              </td>
            </ng-container>
            <ng-template #editTemplate>
              <td class="drag-column"></td>
              <td class="selection" *ngIf="multi"></td>
              <td class="choose-btn"></td>
              <td class="iterator">{{ i + 1 }}</td>
              <td class="note-column">
                <textarea
                  type="text"
                  nz-input
                  [(ngModel)]="newNote.content"
                ></textarea>
              </td>
              <td class="default" *ngIf="supportDefault">
                <label nz-checkbox [(ngModel)]="newNote.isDefault"></label>
              </td>
              <td>
                <button nz-button nzType="link" (click)="save(note)">
                  שמור
                </button>
                <button nz-button nzType="link" (click)="cancel()">בטל</button>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <button
      actions
      nz-button
      (click)="chooseAndClose()"
      *ngIf="setOfCheckedId.size > 0"
    >
      בחר
    </button>
  </authority-labs-base-dialog>
</ng-container>

<ng-template #noteTemplate let-selected>
  <div [authorityLabsAlertColor]="selected?.nzValue">
    {{ selected.nzLabel }}
  </div>
</ng-template>
